import { MenuItem } from "../components/menu/MenuItems";
import { settingsMenuItems } from "../components/menu/SettingsMenuItems";
import { Collection } from "../types/collections.types";
import { UserFromAPI } from "../types/auth.types";
import { NIC_USERS, ROLES } from "./constants";

const getSettingsExclusionsByUser = (
    inclusionsByUser: Array<{ user: string; collection: string }>,
    settingsItems: Array<MenuItem>
) => {
    const inclusionsByUserMap = new Map<string, Array<string>>();
    for (const inclusion of inclusionsByUser) {
        const collections = inclusionsByUserMap.get(inclusion.user) || [];
        collections.push(inclusion.collection);
        inclusionsByUserMap.set(inclusion.user, collections);
    }

    const exclusions: Array<{ user: string; collection: string }> = [];
    for (const [user, allowedCollections] of inclusionsByUserMap) {
        for (const item of settingsItems) {
            if (!allowedCollections.includes(item.collection)) {
                exclusions.push({ user, collection: item.collection });
            }
        }
    }

    return exclusions;
};

const inclusionsByUser = [
    { user: NIC_USERS.daniela_lemos, collection: "processes_parent_category" },
];

const exclusionsByUser = getSettingsExclusionsByUser(inclusionsByUser, settingsMenuItems);

export const getMenuItems = (data: Collection[], formatedMenuItems: MenuItem[], user: UserFromAPI) => {
    const exclusionsByRole = [
        {
            collection: "sessions",
            role: ROLES.accounting,
        },
        {
            collection: "orders",
            role: ROLES.accounting,
        },
        {
            collection: "orders",
            role: ROLES.theurapist,
        },
        {
            collection: "schedules",
            role: ROLES.accounting,
        },
        {
            collection: "bank_transactions",
            role: ROLES.recepcionist,
        },
    ];

    const addEvenIfNoCollection = ["staff-work-logs", "gap-allocator"];

    return formatedMenuItems.filter((formatedItem) => {
        const existsInCollections = data.some(
            (menuItem: Collection) => menuItem.collection === formatedItem.collection
        );
        const alwaysIncluded = addEvenIfNoCollection.includes(formatedItem.collection);
        const isExcludedByRole = exclusionsByRole.some(
            (exclusion) => exclusion.collection === formatedItem.collection && exclusion.role.includes(user.role.id)
        );
        const isExcludedByUser = exclusionsByUser.some(
            (exclusion) => exclusion.collection === formatedItem.collection && exclusion.user === user.id
        );

        return (existsInCollections || alwaysIncluded) && !isExcludedByRole && !isExcludedByUser;
    });
};
